export const links = [
    {
        name: "Home",
        path: "/",
        requiresAuth: false,
        removeOnAuth: false,
    },
    {
        name: "Profile",
        path: "/profile",
        requiresAuth: true,
        removeOnAuth: false,
    },
    {
        name: "View teams",
        path: "/view_teams",
        requiresAuth: false,
        removeOnAuth: false,
    },
    {
        name: "View profiles",
        path: "/view_profiles",
        requiresAuth: false,
        removeOnAuth: false,
    },
    {
        name: "Messages",
        path: "/messages",
        requiresAuth: true,
        removeOnAuth: false,
    },
    {
        name: "Settings",
        path: "/settings",
        requiresAuth: true,
        removeOnAuth: false,
    },
    {
        name: "FAQ",
        path: "/faq",
        requiresAuth: false,
        removeOnAuth: false,
    },
    {
        name: "Sign out",
        path: "/sign_out",
        requiresAuth: true,
        removeOnAuth: false,
    },
    {
        name: "Sign in",
        path: "/sign_in",
        requiresAuth: false,
        removeOnAuth: true,
    },
    {
        name: "Sign up",
        path: "/sign_up",
        requiresAuth: false,
        removeOnAuth: true,
    },
];
